import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { Icon, Style } from "ol/style";
import IconAnchorUnits from "ol/style/IconAnchorUnits";
import nauticalWarningIcon from "~/assets/img/warning_marker.svg";
import { LayerDefaults, LayerTitle } from "../types/layers";
import { readMapSettings } from "./localMapSettings";

interface Return {
  source: VectorSource;
  layer: VectorLayer;
}

export function createNauticalWarningLayer(): Return {
  const source = new VectorSource();
  const title = LayerTitle.NauticalWarnings;
  const icon = `${window.location.origin}${nauticalWarningIcon}`;

  const layer = new VectorLayer({
    source,
    zIndex:
      readMapSettings("layers", title)?.zIndex ?? LayerDefaults[title].zIndex,
    visible:
      readMapSettings("layers", title)?.visible ?? LayerDefaults[title].visible,
    style: new Style({
      image: new Icon({
        opacity: 1,
        src: icon,
        scale: 1.5,
        offset: [0, 0],
        anchor: [0.5, 24],
        anchorXUnits: IconAnchorUnits.FRACTION,
        anchorYUnits: IconAnchorUnits.PIXELS,
      }),
    }),
  });
  layer.set("title", title);
  return { source, layer };
}
